import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    RegisterSuccessWrapper,
    BackgroundImage,
    ContentContainer,
    GalilLogo,
    SuccessTitle,
    SuccessMessage,
    LoginButton,
    SuccessMessageComputer
} from "./styles";
import logo from '../../resources/images/galil-logo.svg';
import backgroundImage from '../../resources/images/login-banner.webp';
import { Route } from "../../routes/Route";

const RegisterSuccessPage: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleLoginClick = () => {
        navigate(`/${Route.Login}`, { replace: true });
    };

    return (
        <RegisterSuccessWrapper>
            <BackgroundImage src={backgroundImage} />
            <ContentContainer>
                <GalilLogo src={logo} alt="Galil Logo" />
                <SuccessTitle>✓ {t('REGISTRATION')}</SuccessTitle>
                <SuccessMessage>
                    {t('REGISTRATION_SUCCESS_MESSAGE')}
                </SuccessMessage>
                <SuccessMessageComputer>
                    שימו לב - הגישה למערכת מתאפשרת באמצעות מחשב בלבד
                </SuccessMessageComputer>
            </ContentContainer>
        </RegisterSuccessWrapper>
    );
};

export default RegisterSuccessPage;
